import { render } from "./product-types.vue?vue&type=template&id=ae89d7de"
import script from "./product-types.vue?vue&type=script&lang=js"
export * from "./product-types.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__